import React from 'react';
import groupBy from 'lodash/groupBy';
import styled from 'styled-components';
import { lineHeight, theme, toRem } from 'design';
import { ITipCalculatorResultSplitCheckReceived } from 'types';
import { centsToDollarsDisplay } from 'utils/currency';

interface ISplitCheckReceivingProps {
  className?: string;
  dataCy?: string;
  values: ITipCalculatorResultSplitCheckReceived[];
}

const Col = styled.div`
  @media (max-width: ${theme.breakpoint.small}) {
    &:not(:first-child),
    &:not(:last-child) {
      display: none;
    }
  }
`;

const ReceivingBreakdownLayout = styled.div`
  display: flex;
  flex-flow: column;
  width: 100%;
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  font-size: ${toRem(theme.font.size.xs)};
  color: ${theme.color.neutral[900]};

  &:not(:last-child) {
    margin-bottom: ${toRem(theme.space.sm)};
  }
`;

const HeaderRow = styled(Row)`
  font-size: ${toRem(theme.font.size.xs)};
  line-height: ${lineHeight(theme.font.size.xs)};
  color: ${theme.color.neutral[500]};
  font-weight: ${theme.font.weight.medium};
`;

const TotalRow = styled(Row)`
  font-weight: ${theme.font.weight.bold};
`;

const SplitChecksReceiving: React.FC<ISplitCheckReceivingProps> = ({ className = '', dataCy = 'split-checks-receiving', values = [] }) => {
  const renderLineItems = () => {
    const groups = groupBy(values, 'displayId');
    return Object.keys(groups).map((id) => (
      <Row key={id} data-cy={`${dataCy}-line-item`}>
        <Col>#{id}</Col>
        <Col>{centsToDollarsDisplay(groups[id].reduce((acc, curr) => acc + curr.totals.total, 0))}</Col>
      </Row>
    ));
  };

  return (
    <ReceivingBreakdownLayout className={className} data-cy={dataCy}>
      <HeaderRow data-cy={`${dataCy}-header`}>
        <Col>Check Number</Col>
        <Col>Amount</Col>
      </HeaderRow>

      {renderLineItems()}

      <TotalRow data-cy={`${dataCy}-total`}>
        <Col>Total</Col>
        <Col>{centsToDollarsDisplay(values.reduce((acc, curr) => acc + curr.totals.total, 0))}</Col>
      </TotalRow>
    </ReceivingBreakdownLayout>
  );
};

export default SplitChecksReceiving;
